import { Component, Input } from '@angular/core';
import { ErrorTrackingService } from '../../services/error-tracking.service';

@Component({
  selector: 'app-error-seguimiento',
  templateUrl: './error-seguimiento.component.html',
  styleUrls: ['./error-seguimiento.component.scss']
})
export class ErrorSeguimientoComponent {

  constructor(public errorTrackingService: ErrorTrackingService) {

  }
}
